import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-900 via-[#0A051E] to-emerald-900 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-8 h-8 text-emerald-400 animate-spin" />
        <p className="text-emerald-300/70 text-sm font-medium">Loading PickStar...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;